import { z } from 'zod';
import {
  EmailValidation,
  ConfirmPasswordValidation,
  NameFormValidation,
  PrivacyPolicyValidation,
} from 'shared/validation/validationTemplates';

export const RegistrationFormValidation = EmailValidation.and(ConfirmPasswordValidation)
  .and(NameFormValidation)
  .and(PrivacyPolicyValidation);

export type TRegistrationFormType = z.infer<typeof RegistrationFormValidation>;
